/* eslint-disable prefer-template */
/* eslint-disable no-unused-vars */
/* eslint-disable one-var */
/* eslint-disable react/prop-types */
import { useState } from "react";
import { useSelector } from 'react-redux';
import ScoreProgressionOverview from "./scoreOverview";

const TARGET = 95;
const MAX_SCORE = 120;
const TOTAL_ATTEMPTS = 6;

function buildAttempts(scoreProgression, assessmentdetails1, userRole, hasScheduledAccess) {
  function calculateAccuracy(correct, incorrect) {
    const denominator = correct + incorrect;
    if (denominator === 0) return 0;
    return (correct / denominator) * 100;
  }

  const isFreeAssessment =
    assessmentdetails1?.is_payment === false &&
    assessmentdetails1?.ispaid === false;
  const attemptsA1 = [
    { label: "Attempt 1", sublabel: "" },
  ];
  const attemptsA1ToA5 = [
    { label: "Attempt 1", sublabel: "" },
    { label: "Attempt 2", sublabel: "" },
    { label: "Attempt 3", sublabel: "" },
    { label: "Attempt 4", sublabel: "" },
    { label: "Attempt 5", sublabel: "" },
  ];

  let slots;
  if (userRole === "AUTH_USER" && hasScheduledAccess) {
    slots = attemptsA1;
  }

  else if (userRole === "AUTH_USER" && !hasScheduledAccess) {
    slots = [
      ...attemptsA1ToA5,
      { label: "Attempt 6", sublabel: "" },
    ];
  } else if (isFreeAssessment) {
    slots = attemptsA1ToA5;
  } else {
    slots = [
      { label: "Free Attempt", sublabel: "" },
      ...attemptsA1ToA5,
    ];
  }

  return slots.map((slot, i) => {
    const match = scoreProgression?.find(
      (s) => s.attemptCount === i
    );

    const accuracy = calculateAccuracy(
      match?.totalCorrectAnswers,
      match?.totalIncorrectAnswers
    );

    return {
      ...slot,
      score: match ? match.totalScore : null,
      overallAccuracy: accuracy ? accuracy.toFixed(2) : 0,
    };
  });
}

function ScoreProgressionChart({ attempts, data, details, assessmentdetails1 }) {

  const W = 560,
    H = 160,
    padL = 46,
    padR = 20,
    padT = 16,
    padB = 8;

  const innerW = W - padL - padR;
  const innerH = H - padT - padB;

  const toX = (i) =>
    attempts.length > 1
      ? padL + (i / (attempts.length - 1)) * innerW
      : padL + innerW / 2;

  // Maximum possible score
  const maxYAxisValue =
    (details || 0) *
    (data?.positiveMarks || 0);

  const maxScore = data?.totalQuestions * data?.positiveMarks;
  const TargetmaxScore = maxScore * 0.9;
  // All actual scores
  const scoreValues = attempts
    .filter((a) => a.score !== null)
    .map((a) => a.score);

  // Include max score so target line fits
  scoreValues.push(maxYAxisValue);

  // Find graph min/max
  const minValue = Math.min(...scoreValues, 0);
  const maxValue = Math.max(...scoreValues, 0);

  // Padding
  const padding = Math.max(
    (maxValue - minValue) * 0.1,
    5
  );

  const graphMin = minValue - padding;
  const graphMax = maxValue + padding;

  const range = graphMax - graphMin || 1;

  // Dynamic Y converter
  const toY = (val) =>
    padT +
    innerH -
    ((val - graphMin) / range) * innerH;

  // Target line
  const targetY = toY(TargetmaxScore);

  const ticks = [
    graphMin,
    graphMin + range * 0.25,
    0,
    graphMin + range * 0.5,
    graphMin + range * 0.75,
    graphMax,
  ];

  // Remove duplicate ticks
  const uniqueTicks = ticks
    .filter((v, i, arr) =>
      arr.findIndex(
        (t) => Math.round(t) === Math.round(v)
      ) === i
    )
    .sort((a, b) => b - a);
  // Scored attempts only
  const scored = attempts.filter(
    (a) => a.score !== null
  );

  // Line points
  const pts = scored.map((a) => {
    const i = attempts.indexOf(a);

    return `${toX(i)},${toY(a.score)}`;
  });

  return (
    <svg
      width="100%"
      viewBox={`0 0 ${W + 40} ${H + 36}`}
      style={{ display: "block" }}
      role="img"
      aria-label="Line chart showing score progression across attempts"
    >
      <title>
        Score progression across attempts
      </title>

      {/* Grid lines */}
      {uniqueTicks.map((tick, idx) => (
        <g key={idx}>
          <line
            x1={padL}
            y1={toY(tick)}
            x2={W - padR}
            y2={toY(tick)}
            stroke="#f0f0f0"
            strokeWidth="1"
          />

          <text
            x={padL - 10}
            y={toY(tick) + 4}
            textAnchor="end"
            fontSize="9"
            fill="#c4c9d4"
            fontFamily="inherit"
          >
            {Math.round(tick)}
          </text>
        </g>
      ))}

      <text
        x={W - padR + 5}
        y={targetY + 4}
        textAnchor="start"
        fontSize="10"
        fill="#16a34a"
        opacity="0.7"
        fontFamily="inherit"
      >
        {Math.round(maxYAxisValue)}
      </text>
      {graphMin <= 0 && graphMax >= 0 && (
        <line
          x1={padL}
          y1={toY(0)}
          x2={W - padR}
          y2={toY(0)}
          stroke="#d1d5db"
          strokeWidth="1.5"
        />
      )}

      {scored.length >= 2 && (
        <polyline
          points={pts.join(" ")}
          fill="none"
          stroke="#378ADD"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}

      {attempts.map((a, i) => {
        const cx = toX(i);
        const hasScore = a.score !== null;
        const cy = hasScore ? toY(a.score) : toY(0);

        const isFirst = i === 0;
        const isNegative = hasScore && a.score < 0;
        let labelX, labelY, labelAnchor;
        if (isNegative) {
          labelX = cx + 10;
          labelY = cy + 4;
          labelAnchor = "start";
        } else if (isFirst) {
          labelX = cx + 6;
          labelY = cy - 8;
          labelAnchor = "start";
        } else {
          labelX = cx;
          labelY = cy - 8;
          labelAnchor = "middle";
        }

        return (
          <g key={i}>
            {hasScore ? (
              <>
                <text
                  x={labelX}
                  y={labelY}
                  textAnchor={labelAnchor}
                  fontSize="11"
                  fontWeight="500"
                  fill="#0C447C"
                  fontFamily="inherit"
                >
                  {a.score}
                </text>

                <circle cx={cx} cy={cy} r="5" fill="#378ADD" stroke="#fff" strokeWidth="2" />
              </>
            ) : (
              <circle cx={cx} cy={toY(0)} r="4" fill="#fff" stroke="#d1d5db" strokeWidth="1.5" />
            )}

            <text
              x={cx}
              y={H + 11}
              textAnchor="middle"
              fontSize="9"
              fill={hasScore ? "#6b7280" : "#d1d5db"}
              fontFamily="inherit"
            >
              {a.label}
            </text>

            {a.sublabel && (
              <text x={cx} y={H + 21} textAnchor="middle" fontSize="9" fill="#c4c9d4" fontFamily="inherit">
                {a.sublabel}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
}

function Card({ children, style }) {
  return <div style={{ background: "#fff", border: "0.5px solid #e5e7eb", borderRadius: "12px", padding: "16px 20px", ...style }}>{children}</div>;
}
function SectionLabel({ children }) {
  return <p style={{ fontSize: "11px", fontWeight: "500", textTransform: "uppercase", letterSpacing: "0.07em", color: "#9ca3af", margin: "0 0 8px" }}>{children}</p>;
}
function StatBlock({ label, value, denom, sub, assessmentdetails1, hasScheduledAccess }) {
  const isFreeAssessment =
    assessmentdetails1?.is_payment === false &&
    assessmentdetails1?.ispaid === false;
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "2px" }}>
      <span style={{ fontSize: "11px", fontWeight: "500", textTransform: "uppercase", letterSpacing: "0.06em", color: "#9ca3af" }}>{label}</span>
      <div style={{ display: "flex", alignItems: "baseline", gap: "2px" }}>
        <span style={{ fontSize: "28px", fontWeight: "500", color: "#111827", lineHeight: 1.1 }}>{value}</span>
        {denom && <span style={{ fontSize: "13px", color: "#9ca3af" }}>{denom}</span>}
      </div>
      {!hasScheduledAccess && sub !== undefined && sub !== null && (
        <span style={{ fontSize: "11px", color: "#9ca3af", marginTop: "1px" }}>
          {sub === 0 ? "Free Attempt" : `Attempt ${isFreeAssessment ? sub : sub}`}
        </span>
      )}
    </div>
  );
}
function StatDivider() {
  return <div style={{ width: "0.5px", background: "#e5e7eb", alignSelf: "stretch", margin: "0 16px" }} />;
}
function RedPill({ children }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "3px", padding: "3px 10px", borderRadius: "999px", background: "#fef2f2", border: "0.5px solid #fecaca", fontSize: "11px", fontWeight: "500", color: "#b91c1c" }}>
      {children}
    </span>
  );
}
function ChartLegend(data) {
  return (
    <div style={{ display: "flex", gap: "14px", marginTop: "10px" }}>
      {[
        { swatch: <span style={{ width: "12px", height: "2px", background: "#378ADD", borderRadius: "2px", display: "inline-block" }} />, label: "Your score" },
        { swatch: <svg width="14" height="4" style={{ display: "inline-block" }}><line x1="0" y1="2" x2="14" y2="2" stroke="#16a34a" strokeWidth="1.5" strokeDasharray="4,3" /></svg>, label: `Target` },
        { swatch: <span style={{ width: "8px", height: "8px", borderRadius: "50%", border: "1.5px solid #d1d5db", display: "inline-block" }} />, label: "Pending" },
      ].map(({ swatch, label }) => (
        <span key={label} style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "#9ca3af" }}>
          {swatch}{label}
        </span>
      ))}
    </div>
  );
}

export default function AssessmentScore({ data, selectedAttemptIndex, details, maxAttempts = 6, assessmentdetails1, hasScheduledAccess, part = "all" }) {
  const userRole = useSelector((state) => state.userInfo && state.userInfo.role);

  const TOTAL_ATTEMPTS = hasScheduledAccess ? 1 : maxAttempts;
  const [selectedAttempt, setSelectedAttempt] = useState("Attempt 1");
  const attempts = buildAttempts(
    data?.scoreProgression,
    assessmentdetails1, userRole, hasScheduledAccess
  );

  

  const currentScore = data?.currentScore ?? 0;
  const accuracy = data?.overallAccuracy ?? 0;
  const scoredCount = attempts.filter((a) => a.score !== null).length;

  const remaining = TOTAL_ATTEMPTS - scoredCount;

  const deltaFromTarget = (details * data?.positiveMarks) - currentScore;
  const pctOfTarget = currentScore > 0 ? Math.round((currentScore / (details * data?.positiveMarks)) * 100) : 0;
  const currentindexScore = attempts && attempts?.length > 0 && attempts[selectedAttemptIndex]?.score || 0;
  // const currentindexaccuracy = data && data?.attemptsAccuracy && data?.attemptsAccuracy[selectedAttemptIndex]?.accuracy || 0;
function calculateAccuracy(correct = 0, incorrect = 0) {
  const c = Number(correct) || 0;
  const i = Number(incorrect) || 0;
  const denominator = c + i;
  if (denominator === 0) return (0).toFixed(2);
  return ((c / denominator) * 100).toFixed(2);
}

const attempt = data?.attemptsAccuracy?.[selectedAttemptIndex];
const currentindexaccuracy = calculateAccuracy(attempt?.correct, attempt?.incorrect)

  const latestAttemptLabel = data?.scoreProgression?.length
    ? `Attempt ${data.scoreProgression[data.scoreProgression.length - 1].attemptCount + 1}`
    : "—";

  const scoreBlock = (
    <StatBlock
      label="Score"
      value={currentindexScore}
      denom={`/${data?.positiveMarks ? (details * data?.positiveMarks) : 0}`}
      sub={`${pctOfTarget}% of target`}
      assessmentdetails1={assessmentdetails1}
      hasScheduledAccess={hasScheduledAccess}
    />
  );
  const accuracyBlock = (
    <StatBlock
      label="Accuracy"
      value={currentindexaccuracy}
      denom="%"
      sub={selectedAttemptIndex}
      assessmentdetails1={assessmentdetails1}
      hasScheduledAccess={hasScheduledAccess}
    />
  );
  const attemptsBlock = (
    <StatBlock
      label="Attempts"
      value={scoredCount}
      denom={`/${TOTAL_ATTEMPTS}`}
      sub={`${remaining} remaining`}
      assessmentdetails1={assessmentdetails1}
      hasScheduledAccess={hasScheduledAccess}
    />
  );

  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans','DM Sans',-apple-system,BlinkMacSystemFont,sans-serif", display: "flex", flexDirection: "column", gap: "8px", padding: "4px 0", width: "100%", height: part === "chart" ? "100%" : undefined }}>

      {part === "stats" && (
        <>
          <div className="md:hidden">
            <Card style={{ display: "flex", alignItems: "stretch" }}>
              {scoreBlock}
              <StatDivider />
              {accuracyBlock}
              <StatDivider />
              {attemptsBlock}
            </Card>
          </div>

          <div className="hidden md:grid grid-cols-3 gap-4">
            <Card>{scoreBlock}</Card>
            <Card>{accuracyBlock}</Card>
            <Card>{attemptsBlock}</Card>
          </div>
        </>
      )}

      {part === "all" && (
        <Card style={{ display: "flex", alignItems: "stretch" }}>
          {scoreBlock}
          <StatDivider />
          {accuracyBlock}
          <StatDivider />
          {attemptsBlock}
        </Card>
      )}

      {part !== "stats" && (
        <ScoreProgressionOverview
          attempts={attempts.map((a) => ({ title: a.label }))}
          scoreProgression={data?.scoreProgression}
          maxScore={
            data?.positiveMarks
              ? (details || 0) * data.positiveMarks
              : Number(assessmentdetails1?.total_marks) || 0
          }
        />
      )}
    </div>
  );
}